import {
    ForgotPasswordContent,
    ForgotPasswordRouteConfig,
    ForgotPasswordSocialLink,
} from "./ForgotPasswordTypes";

export const forgotPasswordRoutes: ForgotPasswordRouteConfig = {
    home: "/HomePage",
    signIn: "/SignIn",
};

export const forgotPasswordContent: ForgotPasswordContent = {
    eyebrow: "ACCOUNT RECOVERY",
    title: "Forgot your password?",
    resetTitle: "Reset your password",
    subtitle:
        "Enter your registered Email ID. We’ll send an OTP to help you reset your password.",
    resetSubtitle:
        "Enter the OTP sent to your email along with your new password.",
    inputPlaceholder: "Enter Email ID",
    otpPlaceholder: "Enter 6-digit OTP",
    newPasswordPlaceholder: "New Password (min 8 chars)",
    confirmPasswordPlaceholder: "Confirm New Password",
    sendOtpLabel: "Send OTP",
    sendingOtpLabel: "Sending OTP...",
    sentOtpLabel: "OTP Sent",
    resetPasswordLabel: "Reset Password",
    resettingPasswordLabel: "Resetting Password...",
    backToEmailLabel: "Back to Email",
    backToSignInLabel: "Back to Sign In",
    socialTitle: "Follow Salar social media official accounts",
    brandAlt: "Salar",
    heroAlt: "Salar shopping experience",
    successMessage: "OTP has been sent to your registered email.",
    resetSuccessMessage: "Password reset successful! Redirecting to Sign In...",
};

export const forgotPasswordSocialLinks: ForgotPasswordSocialLink[] = [
    {
        id: "instagram",
        label: "Instagram",
        href: "https://www.instagram.com",
        iconClass: "bi bi-instagram",
    },
    {
        id: "facebook",
        label: "Facebook",
        href: "https://www.facebook.com",
        iconClass: "bi bi-facebook",
    },
    {
        id: "whatsapp",
        label: "WhatsApp",
        href: "https://www.whatsapp.com",
        iconClass: "bi bi-whatsapp",
    },
    {
        id: "x",
        label: "X",
        href: "https://x.com",
        iconClass: "bi bi-twitter-x",
    },
    {
        id: "youtube",
        label: "YouTube",
        href: "https://www.youtube.com",
        iconClass: "bi bi-youtube",
    },
];
